import React from 'react';
import ScrollIntoView from '../components/ScrollIntoView';

const Public = () => {
  return (
    <ScrollIntoView>
      <div id="public-page">
        <section>
          <h1>Közérdekű adatok</h1>
          <div id="public-links">
            <a href="/kozerdeku/Egyszerűsített évesbeszámoló 2020.év.pdf" target="_blank" rel="noopener noreferrer">Egyszerűsített évesbeszámoló 2020.év</a>
            <a href="/kozerdeku/Kiegészítő melléklet 2020.év.pdf" target="_blank" rel="noopener noreferrer">Kiegészítő melléklet 2020.év</a>
            <a href="/kozerdeku/Adatvédelmi szabályzat.pdf" target="_blank" rel="noopener noreferrer">Adatvédelmi szabályzat</a>
            <a href="/kozerdeku/2021. évi egyszerűsített éves beszámoló.pdf" target="_blank" rel="noopener noreferrer">2021. évi egyszerűsített éves beszámoló</a>
            <a href="/kozerdeku/2021. évi kiegészítő melléklet.pdf" target="_blank" rel="noopener noreferrer">2021. évi kiegészítő melléklet</a>
            <a href="/kozerdeku/2022. évi egyszerűsített évesbeszámoló.pdf" target="_blank" rel="noopener noreferrer">2022. évi egyszerűsített évesbeszámoló</a>
            <a href="/kozerdeku/2022. évi kiegészítő melléklet.pdf" target="_blank" rel="noopener noreferrer">2022. évi kiegészítő melléklet</a>
            <a href="/kozerdeku/Foglalkoztatottak létszáma személyi juttatása.pdf" target="_blank" rel="noopener noreferrer">Foglalkoztatottak létszáma személyi juttatása</a>
            <a href="/kozerdeku/Egyszerusitett_eves_beszamolo_20240426_0001.pdf" target="_blank" rel="noopener noreferrer">2023_evi_Egyszerusitett_eves_beszamolo</a>
            <a href="/kozerdeku/Kiegeszito_melleklet_20240430_0001.pdf" target="_blank" rel="noopener noreferrer">2023_evi_Kiegeszito_melleklet</a>
            <a href="/kozerdeku/Vezeto_tisztsegviselok_dijazasa.pdf" target="_blank" rel="noopener noreferrer">Vezeto_tisztsegviselok_dijazasa</a>
            </div>
          </section>
        </div>

    </ScrollIntoView>
  );
};

export default Public;